import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import styles from './PricingTable.module.css';

const PricingTable = ({ currentPlan, token, email, origin, handleActivePaymentProgress = ()=>{} }) => {


  const history = useHistory();

  const handleClick = (plan) => {
    // Logic to handle plan selection

    if(origin === 'dashboard' && plan=='Basic'){
      handleActivePaymentProgress();
      return;
    }
   
    if (origin === 'demo') {
      if (plan == 'Free') {
        history.push(`/login`);
      } else if (plan == 'Basic') {
        if (token) {
          window.location.href = 'https://buy.stripe.com/test_7sIdTocj02dU0qkeUZ?prefilled_email=' + email.trim()
        } else {
          history.push(`/login?redirect=stripe&plan=${plan.toLowerCase()}`);
        }
      }
    }

    if (origin === 'subscriptions') {
      if (plan == 'Free') {
        history.push(`/login?redirect=chatbot`);
      } else if (plan == 'Basic') {
        if (token) {
          window.location.href = 'https://buy.stripe.com/test_7sIdTocj02dU0qkeUZ?prefilled_email=' + email.trim()
        } else {
          history.push(`/login?redirect=stripe&plan=${plan.toLowerCase()}`);
        }
      }
    }

  }

  return (
    <div className={styles.pricingContainer}>
      <div className={styles.scrollWrapper}>
        <table className={styles.pricingTable}>
          <thead>
            <tr>
              <th>Feature</th>
              <th>Free</th>
              <th>Basic</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Number of Projects</td>
              <td>1</td>
              <td><b>3</b></td>
            </tr>
            <tr>
              <td>File Storage</td>
              <td>500 MB</td>
              <td><b>10 GB</b></td>
            </tr>
            <tr>
              <td>Users per Project</td>
              <td>1</td>
              <td><b>Up to 5 users</b></td>
            </tr>
            <tr>
              <td>AI Agent Queries</td>
              <td>50 / month</td>
              <td><b>500 / month</b></td>
            </tr>
            <tr>
              <td>AI Document Analysis</td>
              <td>
                <i className={`bi bi-x-lg ${styles.iconCross}`}></i>
              </td>
              <td>
                <i className={`bi bi-check-lg ${styles.iconCheck}`}></i> (Up to 10 per project)
              </td>
            </tr>
            <tr>
              <td>Conversation History</td>
              <td>Last 7 days</td>
              <td><b>Full History</b></td>
            </tr>
            <tr>
              <td>Support</td>
              <td>Community</td>
              <td><b>Priority Email</b></td>
            </tr>
            <tr>
              <td></td>
              <td>
                <button className={styles.button} disabled={['Free', 'Basic'].includes(currentPlan)} onClick={() => { handleClick('Free') }}>Start for Free</button>
              </td>
              <td>
                <button className={`${styles.button} ${styles.btnPrimary}`} disabled={['Basic'].includes(currentPlan)} onClick={() => { handleClick('Basic') }}>
                  Get Basic
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PricingTable;